import { _ as o } from "./index.es502.js";

var r = o,
    n = function n() {
  return r.Date.now();
},
    a = n;

export { a as n };